import React, { useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { authAPI } from '@/service/admin';
import './index.scss';

const menuItems = [
  { path: '/admin/write', label: '写文章', icon: '✍️' },
  { path: '/admin/articles', label: '文章管理', icon: '📄' },
  { path: '/admin/interview', label: '面试题', icon: '✍️' },
  { path: '/admin/interview-manage', label: '面试题管理', icon: '📄' },
  { path: '/admin/tags', label: '标签管理', icon: '🏷️' },
];

const AdminLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    authAPI.logout().then(() => {
      localStorage.removeItem('token');
      navigate('/admin/login');
    });
  };

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/admin/login');
    }
  }, []);

  return (
    <div className="admin-layout">
      {/* 左侧边栏 */}
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <h2 className="sidebar-logo">阿呆的博客</h2>
          <p className="sidebar-subtitle">管理后台</p>
        </div>

        <nav className="sidebar-nav">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `sidebar-link ${isActive ? 'active' : ''}`
              }
            >
              <span className="sidebar-link-icon">{item.icon}</span>
              <span className="sidebar-link-label">{item.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-footer">
          <button className="sidebar-logout-btn" onClick={handleLogout}>
            <span className="sidebar-link-icon">🚪</span>
            <span>退出登录</span>
          </button>
        </div>
      </aside>

      {/* 右侧内容区 */}
      <main className="admin-content">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;
